// extracted by mini-css-extract-plugin
export var scrollArea = "_od-0";